export default __webpack_public_path__ + "static/media/axeconstructions.6cf4fc5f.png";